import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import type { DiffEntry } from '@/utils/AuditTrail/types';

export const DiffTable: React.FC<{ diff: DiffEntry[] }> = ({ diff }) => (
  <div className="mt-2">
    <p className="text-xs font-semibold text-muted-foreground mb-1.5">Changes made:</p>
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="py-1.5 text-xs h-auto">Field</TableHead>
          <TableHead className="py-1.5 text-xs h-auto">Previous Value</TableHead>
          <TableHead className="py-1.5 text-xs h-auto">New Value</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {diff.map((d, i) => (
          <TableRow key={i}>
            <TableCell className="py-1.5 text-xs font-medium">{d.field}</TableCell>
            <TableCell className="py-1.5 text-xs text-error-700 line-through">{d.previousValue}</TableCell>
            <TableCell className="py-1.5 text-xs text-success-700">{d.newValue}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);
